import { useApiMutation } from "../../../../../../../core/api/useApiMutation"
import { ConfirmModal } from "../../../../../../../shared/components/dialogs/ConfirmModal"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { deleteMeetingServiceOrders, MerchantMeetingServiceOrdersQuery } from "../../meetingServiceApi"
import { MeetingServiceOrder } from "../../meetingServiceTypes"
import { MeetingServiceDeleteDialogContent } from "../../components/MeetingServiceDialogContent"

type Props = Readonly<{
    orders: MeetingServiceOrder[]
    onClose: () => void
    onDeleted: () => void
}>

export function ProductionDeleteDialog({ orders, onClose, onDeleted }: Props) {
    const { l10n } = useAppLocalization()

    const { mutate: deleteOrder, isLoading: isDeleting } = useApiMutation(deleteMeetingServiceOrders, {
        async onSuccess(_params, _data, context) {
            await context.queryClient.invalidateQueries({
                queryKey: [MerchantMeetingServiceOrdersQuery.MEETING_SERVICE],
            })
        },
    })

    const handleConfirm = () => {
        deleteOrder({ orderIds: orders.map((order) => order.id), cancelMeetingService: true })
        onDeleted()
    }

    return (
        <ConfirmModal
            open
            hideCloseIcon={false}
            title={l10n.getString("meeting-service-delete-orders-title")}
            buttonLabelSubmit={l10n.getString("meeting-service-delete-orders-button")}
            buttonSubmitLoading={isDeleting}
            handleClick={handleConfirm}
            onClose={onClose}
            maxWidthProp="sm"
        >
            <MeetingServiceDeleteDialogContent
                isProductionView
                hasDeleteMessage
                hideBooking
                list={orders}
                checked={false}
                handleChange={() => {}}
            />
        </ConfirmModal>
    )
}
